<div class="modal inmodal fade in view-attachment-modal" [ngClass]="{'show': ds.isDocumentViewModalShow}">
    <div class="modal-dialog" style="max-height: calc(100vh - 215px); overflow: auto;">
        <div class="modal-content">

            <h3>{{ds.documentInViewModal.name}}</h3>

            <button type="button" class="close" (click)="ds.hideImage()">
                <span>×</span><span class="sr-only">Close</span>
            </button>

            <img [src]="ds.documentInViewModal.path">
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="ds.hideImage()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-view-modal/documents-view-modal.component.html